document.addEventListener('click', (e) => {
    if (e.target.classList.contains('ac-header')) {
        const accordionBody = e.target.nextElementSibling
        const accordionHeader = e.target
        accordionHeader.classList.toggle('active')
        accordionBody.classList.toggle('active')
    }
    if (e.target.classList.contains('ac-footer')) {
        const accordionBody = e.target.previousElementSibling
        const accordionHeader = e.target
        accordionHeader.classList.toggle('active')
        accordionBody.classList.toggle('active')
    }

    const notes = document.querySelector('#kco-order-review .form-row label')
    if (e.target === notes) {
        const accordionHeader = notes.parentNode
        const accordionBody = notes.nextElementSibling
        accordionHeader.classList.toggle('active')
        accordionBody.classList.toggle('active')
    }
})
